import isEmpty from 'lodash/isEmpty';

export default function asArray<T>(item: T | T[] | undefined): T[] {
  if (Array.isArray(item)) return item;
  if (!item || isEmpty(item)) return [];
  return [item];
}
